import React from 'react'
import { Trans } from '@lingui/macro'
import { ButtonPrimary, ButtonLight } from 'front-end/src/components'

type ModalFilterEntitiesControlsProps = {
  handleCancel: () => void
  handleSubmit: () => void
}
export const ModalFilterEntitiesControls =
  React.memo<ModalFilterEntitiesControlsProps>(
    ({ handleCancel, handleSubmit }) => (
      <>
        <ButtonLight onClick={handleCancel}>
          <Trans>Cancel</Trans>
        </ButtonLight>
        <ButtonPrimary onClick={handleSubmit}>
          <Trans>Set filter</Trans>
        </ButtonPrimary>
      </>
    )
  )
